var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-auth"},[_c('img',{staticClass:"logo",attrs:{"src":require("assets/img/logo.png")}}),_vm._v(" "),_c('mu-button',{staticClass:"button",attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("确认登录")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b085e05","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wechat/login.vue
// module id = null
// module chunks = 